import classes from "./TabsulQuiz.module.css";
import logo from "../Assets/green.png";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { asyncNext, setAnswer,} from "../Store/StaffReducer/staffSlice";
import Loading from "../Components/Loading";
import Error from "../Components/Error";
import FirstAd from "./FirstAd";

const TabsulQuiz = () => {

  const { id } = useParams();
  const dispatch = useDispatch();

  const data = useSelector((state) => state.staff.data);
  const loading = useSelector((state) => state.staff.loading);
  const error = useSelector((state) => state.staff.error);

  const [qsnumber, setQsnumber] = useState(0);
  const [result, setResult] = useState(0);



  // const goback = () => {
  //   navigate("/"); // redirect to home
  // };

  useEffect(() => {
    dispatch(asyncNext({ id }));
  }, [id, dispatch]);

  const handleAnswer = (option) => {
    if (!data.selected) {
      dispatch(setAnswer(option))
    }
  }

  const nextButtonHandler = () => {
    if (data.selected) {
      dispatch(asyncNext({ id }))
    }
    if (data.selected === data.Correct) {
      setResult(result + 1);
    }
    setQsnumber(qsnumber + 1);
  }

  const bgColor = (option) => {
    console.log(option, data.Correct, data.selected)
    if (option === data.Correct && data.selected) {
      return "#0F8B50"; // Green for correct answer
    } else if (option === data.selected && option !== data.Correct) {
      return "#FF0000"; // Red for selected wrong answer
    }
  }

  const borderColor = (option) => {
    console.log(option, data.Correct, data.selected)
    if (option === data.Correct && data.selected) {
      return "#0F8B50"; // Green for correct answer
    } else if (option === data.selected && option !== data.Correct) {
      return "#FF0000"; // Red for selected wrong answer
    }
  }


  const fontColor = (option) => {
    console.log(option, data.Correct, data.selected)
    if (option === data.Correct && data.selected) {
      return "#FFFFFF"; // Green for correct answer
    } else if (option === data.selected && option !== data.Correct) {
      return "#FFFFFF"; // Red for selected wrong answer
    } else {
      return "#000000"; // Default black text
    }
  }


  if (error) {
    return <Error message="Failed to load quiz data. Please try again." />;
  }


  return (
    <div className={classes.page}>

      <section className={classes.hero}>
        <img src={logo} alt="Tabsul Logo" className={classes.heroLogo} />
      </section>

      <div className={classes.center}>
        <div className={classes.timerhead}>
          <div className={classes.timer}>
            <p>{qsnumber ? ((result / qsnumber) * 100).toFixed(1) : 0} %</p>
          </div>
          <div className={classes.qsnumber}>
            <p>{qsnumber + 1}</p>
          </div>
        </div>
      </div>

      {/* QUESTIONS */}

      {loading ? <Loading top = '100px'/> :

      <>

      <div className={classes.QsSection}>
        <div className={classes.question}>
          <p>{data.question}</p>
        </div>

        <div className={classes.options}>
          {['A', 'B', 'C', 'D'].map((option) => (
            <div
              key={option}
              className={classes.optionButton}
              onClick={() => handleAnswer(option)}
              style={{ backgroundColor: bgColor(option), borderColor: borderColor(option) }}
            >
              <p style={{ color: fontColor(option) }}>{data[option]}</p>
            </div>
          ))}
        </div>

        {data.selected && <div className={classes.question}>
          <p>{data.description}</p>
        </div>}
      </div>

      <FirstAd />



      {/* NAVIGATION BUTTONS */}
      <div className={classes.navButtons}>
        <button onClick={nextButtonHandler} className={classes.nextButton}>
          Next
        </button>
      </div>

      </>}

    </div>
  );
};

export default TabsulQuiz;